module.exports = __webpack_public_path__ + "static/media/55.b60d53a6.jpg";